export default __webpack_public_path__ + "static/crab_station_menu-0f82553b534c368327157ffd0e68a0fc.pdf";